import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, SlotLayout } from 'editor/src/store/design/types';

const setSlotLayoutReducer = (
  state: DesignState,
  action: PayloadAction<{ spreadIndex: number; layout: SlotLayout }>,
) => {
  const { spreadIndex, layout } = action.payload;
  const spread = state.designData?.spreads[spreadIndex];
  if (!spread) {
    return;
  }
  const layouts = spread.slotLayouts ?? [];
  const index = layouts.findIndex((item) => item.id === layout.id);
  if (index === -1) {
    layouts.push(layout);
  } else {
    layouts[index] = layout;
  }
  spread.slotLayouts = layouts;
};

export default setSlotLayoutReducer;
